export enum CustomerOrProviderEnum {
  provider = 'fornecedores',
  customer = 'clientes',
}
